import projects from '../data/projects';
import ArtworkCredit from './ArtworkCredit';
import ArtworkSection from './ArtworkSection';
import ProjectItem from './ProjectItem';

const workImage = {
    jpg: '/art/western-luminism/mount-corcoran-bierstadt-1920.jpg',
    srcSet: [
        '/art/western-luminism/mount-corcoran-bierstadt-1280.jpg 1280w',
        '/art/western-luminism/mount-corcoran-bierstadt-1920.jpg 1920w',
    ].join(', '),
};

function WorkSection() {
    return (
        <ArtworkSection id="work" className="content-slide" image={workImage}>
            <div className="slide-copy wide-copy">
                <p className="section-name">Selected work</p>
                <div className="line-list">
                    {projects.map((project) => <ProjectItem key={project.name} {...project} />)}
                </div>
            </div>
            <ArtworkCredit>
                Albert Bierstadt · <cite>Mount Corcoran</cite> · ca. 1876–77
            </ArtworkCredit>
        </ArtworkSection>
    );
}

export default WorkSection;
